import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { CloseIcon, PlusIcon, ChevronDownIcon } from "@graphiql/react";
import { isNonNullType, isListType, isInputObjectType, getNamedType, isEnumType, isScalarType } from "graphql";
import { useState } from "react";
import { BooleanArgControl, ScalarArgControl } from "./scalar-arg-control.js";
import { EnumArgControl } from "./enum-arg-control.js";
function rendersAsInputObject(type) {
  const unwrapped = isNonNullType(type) ? type.ofType : type;
  if (isListType(unwrapped)) {
    return false;
  }
  return isInputObjectType(getNamedType(unwrapped));
}
const ArgInputByType = (t0) => {
  const $ = c(58);
  const {
    type,
    name,
    value,
    onChange,
    isVariable: t1,
    variableName,
    onPromote,
    onDemote
  } = t0;
  const isVariable = t1 === void 0 ? false : t1;
  if (isNonNullType(type)) {
    let t22;
    if ($[0] !== isVariable || $[1] !== name || $[2] !== onChange || $[3] !== onDemote || $[4] !== onPromote || $[5] !== type.ofType || $[6] !== value || $[7] !== variableName) {
      t22 = /* @__PURE__ */ jsx(ArgInputByType, { type: type.ofType, name, value, onChange, isVariable, variableName, onPromote, onDemote });
      $[0] = isVariable;
      $[1] = name;
      $[2] = onChange;
      $[3] = onDemote;
      $[4] = onPromote;
      $[5] = type.ofType;
      $[6] = value;
      $[7] = variableName;
      $[8] = t22;
    } else {
      t22 = $[8];
    }
    return t22;
  }
  if (isListType(type)) {
    let t22;
    if ($[9] !== value) {
      t22 = Array.isArray(value) ? value : [];
      $[9] = value;
      $[10] = t22;
    } else {
      t22 = $[10];
    }
    let t32;
    if ($[11] !== name || $[12] !== onChange || $[13] !== t22 || $[14] !== type.ofType) {
      t32 = /* @__PURE__ */ jsx(ListArgInput, { itemType: type.ofType, name, value: t22, onChange });
      $[11] = name;
      $[12] = onChange;
      $[13] = t22;
      $[14] = type.ofType;
      $[15] = t32;
    } else {
      t32 = $[15];
    }
    return t32;
  }
  let named;
  let t2;
  let t3;
  let toggleBtn;
  if ($[16] !== isVariable || $[17] !== name || $[18] !== onChange || $[19] !== onDemote || $[20] !== onPromote || $[21] !== type || $[22] !== value || $[23] !== variableName) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      named = getNamedType(type);
      if (isInputObjectType(named)) {
        let t42;
        if ($[28] !== value) {
          t42 = !Array.isArray(value) && typeof value === "object" && value !== null ? value : {};
          $[28] = value;
          $[29] = t42;
        } else {
          t42 = $[29];
        }
        const objValue = t42;
        t3 = /* @__PURE__ */ jsx(InputObjectArgInput, { inputType: named, name, value: objValue, onChange });
        break bb0;
      }
      let t4;
      if ($[30] !== isVariable || $[31] !== name || $[32] !== onDemote || $[33] !== onPromote || $[34] !== variableName) {
        t4 = onPromote ? /* @__PURE__ */ jsx("button", { type: "button", className: "graphiql-qb-var-toggle", "aria-pressed": isVariable, onClick: () => {
          if (isVariable) {
            if (onDemote && variableName) {
              onDemote(name, variableName);
            }
          } else {
            onPromote(name, name);
          }
        }, children: isVariable ? "Inline argument" : "Use as variable" }) : null;
        $[30] = isVariable;
        $[31] = name;
        $[32] = onDemote;
        $[33] = onPromote;
        $[34] = variableName;
        $[35] = t4;
      } else {
        t4 = $[35];
      }
      toggleBtn = t4;
      if (isEnumType(named)) {
        t3 = /* @__PURE__ */ jsx(WithVariableToggle, { isVariable, name, variableName, toggle: toggleBtn, children: /* @__PURE__ */ jsx(EnumArgControl, { name, value: typeof value === "string" ? value : "", onChange, enumValues: named.getValues().map(_temp) }) });
        break bb0;
      }
      t2 = isScalarType(named);
    }
    $[16] = isVariable;
    $[17] = name;
    $[18] = onChange;
    $[19] = onDemote;
    $[20] = onPromote;
    $[21] = type;
    $[22] = value;
    $[23] = variableName;
    $[24] = named;
    $[25] = t2;
    $[26] = t3;
    $[27] = toggleBtn;
  } else {
    named = $[24];
    t2 = $[25];
    t3 = $[26];
    toggleBtn = $[27];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  if (t2) {
    if (named.name === "Boolean") {
      const t42 = typeof value === "string" ? value : "";
      let t52;
      if ($[36] !== name || $[37] !== onChange || $[38] !== t42) {
        t52 = /* @__PURE__ */ jsx(BooleanArgControl, { name, value: t42, onChange });
        $[36] = name;
        $[37] = onChange;
        $[38] = t42;
        $[39] = t52;
      } else {
        t52 = $[39];
      }
      let t62;
      if ($[40] !== isVariable || $[41] !== name || $[42] !== t52 || $[43] !== toggleBtn || $[44] !== variableName) {
        t62 = /* @__PURE__ */ jsx(WithVariableToggle, { isVariable, name, variableName, toggle: toggleBtn, children: t52 });
        $[40] = isVariable;
        $[41] = name;
        $[42] = t52;
        $[43] = toggleBtn;
        $[44] = variableName;
        $[45] = t62;
      } else {
        t62 = $[45];
      }
      return t62;
    }
    const inputType = named.name === "Int" || named.name === "Float" ? "number" : "text";
    const t4 = named.name === "Int" ? "1" : void 0;
    const t5 = typeof value === "string" ? value : "";
    let t6;
    if ($[46] !== inputType || $[47] !== name || $[48] !== onChange || $[49] !== t4 || $[50] !== t5) {
      t6 = /* @__PURE__ */ jsx(ScalarArgControl, { name, inputType, step: t4, value: t5, onChange });
      $[46] = inputType;
      $[47] = name;
      $[48] = onChange;
      $[49] = t4;
      $[50] = t5;
      $[51] = t6;
    } else {
      t6 = $[51];
    }
    let t7;
    if ($[52] !== isVariable || $[53] !== name || $[54] !== t6 || $[55] !== toggleBtn || $[56] !== variableName) {
      t7 = /* @__PURE__ */ jsx(WithVariableToggle, { isVariable, name, variableName, toggle: toggleBtn, children: t6 });
      $[52] = isVariable;
      $[53] = name;
      $[54] = t6;
      $[55] = toggleBtn;
      $[56] = variableName;
      $[57] = t7;
    } else {
      t7 = $[57];
    }
    return t7;
  }
  return null;
};
const WithVariableToggle = (t0) => {
  const $ = c(8);
  const {
    isVariable,
    name,
    variableName,
    toggle,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== isVariable || $[2] !== name || $[3] !== variableName) {
    t1 = isVariable ? /* @__PURE__ */ jsxs("span", { className: "graphiql-qb-var-badge", "aria-label": `${name} bound to $${variableName ?? name}`, children: [
      "$",
      variableName ?? name
    ] }) : children;
    $[0] = children;
    $[1] = isVariable;
    $[2] = name;
    $[3] = variableName;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1 || $[6] !== toggle) {
    t2 = /* @__PURE__ */ jsxs("span", { className: "graphiql-qb-arg-with-toggle", children: [
      t1,
      toggle
    ] });
    $[5] = t1;
    $[6] = toggle;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
const withIds = (values) => values.map((value) => ({
  id: crypto.randomUUID(),
  value
}));
const projectItems = (items) => items.map((i) => i.value).filter((v) => v !== "");
const ListArgInput = (t0) => {
  const $ = c(21);
  const {
    itemType,
    name,
    value,
    onChange
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = () => withIds(value);
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [items, setItems] = useState(t1);
  let t2;
  if ($[2] !== value) {
    t2 = JSON.stringify(value);
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const valueJSON = t2;
  const [syncedJSON, setSyncedJSON] = useState(valueJSON);
  if (valueJSON !== syncedJSON) {
    setSyncedJSON(valueJSON);
    if (valueJSON !== JSON.stringify(projectItems(items))) {
      setItems(withIds(value));
    }
  }
  let t3;
  if ($[4] !== onChange) {
    t3 = (next) => {
      setItems(next);
      onChange(next.map(_temp2));
    };
    $[4] = onChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const emit = t3;
  let t4;
  if ($[6] !== emit || $[7] !== itemType || $[8] !== items || $[9] !== name) {
    t4 = items.map((item) => /* @__PURE__ */ jsxs("div", { className: "graphiql-qb-list-item", children: [
      /* @__PURE__ */ jsx(ArgInputByType, { type: itemType, name, value: item.value, onChange: (v) => emit(items.map((i_0) => i_0.id === item.id ? {
        ...i_0,
        value: v
      } : i_0)) }),
      /* @__PURE__ */ jsx("button", { type: "button", onClick: () => emit(items.filter((i_1) => i_1.id !== item.id)), "aria-label": "Remove item", className: "graphiql-qb-list-remove", children: /* @__PURE__ */ jsx(CloseIcon, {}) })
    ] }, item.id));
    $[6] = emit;
    $[7] = itemType;
    $[8] = items;
    $[9] = name;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== emit || $[12] !== itemType || $[13] !== items) {
    t5 = () => emit([...items, {
      id: crypto.randomUUID(),
      value: defaultValueForType(itemType)
    }]);
    $[11] = emit;
    $[12] = itemType;
    $[13] = items;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = /* @__PURE__ */ jsx(PlusIcon, {});
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5) {
    t7 = /* @__PURE__ */ jsxs("button", { type: "button", onClick: t5, "aria-label": "Add item", className: "graphiql-qb-list-add", children: [
      t6,
      "Add"
    ] });
    $[16] = t5;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t4 || $[19] !== t7) {
    t8 = /* @__PURE__ */ jsxs("div", { className: "graphiql-qb-list-arg", children: [
      t4,
      t7
    ] });
    $[18] = t4;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
function defaultValueForType(type) {
  if (isNonNullType(type)) {
    return defaultValueForType(type.ofType);
  }
  if (isListType(type)) {
    return [];
  }
  const named = getNamedType(type);
  if (isInputObjectType(named)) {
    return {};
  }
  return "";
}
const InputObjectArgInput = (t0) => {
  const $ = c(15);
  const {
    inputType,
    name,
    value,
    onChange
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] !== inputType || $[1] !== name || $[2] !== onChange || $[3] !== open || $[4] !== value) {
    const fields = inputType.getFields();
    const onChangeField = (fieldName, fieldValue) => {
      const next = {
        ...value
      };
      if (fieldValue === "" || fieldValue === void 0) {
        delete next[fieldName];
      } else {
        next[fieldName] = fieldValue;
      }
      onChange(next);
    };
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = (e) => setOpen(e.currentTarget.open);
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    const t3 = open ? "graphiql-qb-chevron-expanded" : "graphiql-qb-chevron-collapsed";
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = /* @__PURE__ */ jsx(ChevronDownIcon, {});
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== t3) {
      t5 = /* @__PURE__ */ jsx("span", { className: t3, children: t4 });
      $[8] = t3;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    let t6;
    if ($[10] !== name) {
      t6 = /* @__PURE__ */ jsx("span", { className: "graphiql-qb-arg-name", children: name });
      $[10] = name;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== t5 || $[13] !== t6) {
      t7 = /* @__PURE__ */ jsxs("summary", { className: "graphiql-qb-input-object-summary", children: [
        t5,
        t6
      ] });
      $[12] = t5;
      $[13] = t6;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    t1 = /* @__PURE__ */ jsxs("details", { className: "graphiql-qb-input-object", onToggle: t2, children: [
      t7,
      open && /* @__PURE__ */ jsx("div", { className: "graphiql-qb-input-object-fields", children: Object.entries(fields).map((t8) => {
        const [fieldName_0, field] = t8;
        const fieldVal = value[fieldName_0] ?? "";
        const isObjectField = rendersAsInputObject(field.type);
        return /* @__PURE__ */ jsxs("div", { className: "graphiql-qb-arg-row", children: [
          !isObjectField && /* @__PURE__ */ jsxs("span", { className: "graphiql-qb-arg-name", children: [
            fieldName_0,
            ":"
          ] }),
          /* @__PURE__ */ jsx(ArgInputByType, { type: field.type, name: fieldName_0, value: fieldVal, onChange: (v) => onChangeField(fieldName_0, v) })
        ] }, fieldName_0);
      }) })
    ] });
    $[0] = inputType;
    $[1] = name;
    $[2] = onChange;
    $[3] = open;
    $[4] = value;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
function _temp(v) {
  return v.name;
}
function _temp2(i) {
  return i.value;
}
export {
  ArgInputByType,
  rendersAsInputObject
};
//# sourceMappingURL=arg-input-by-type.js.map
